import React from 'react';
import { AriaAnnouncer } from './AriaAnnouncer';
import AppShell from './AppShell';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => (
  <AppShell>
    <AriaAnnouncer />
    {children}
  </AppShell>
);